import { Record, Map, List } from 'immutable';
import _ from 'lodash';

import Station from './Station';
import StationStop from './StationStop';
import { resolveAll } from '../helpers/LinkMapper';
import { StopPatterns } from '../constants/AppConstants';


const CallingPoints = new Record({
    id: null,
    route: new Map()
});

Object.assign(CallingPoints.prototype, {

    getOrigin () {
        return this.route.first().first();
    },

    getDestination () {
        return this.route.last().last();
    },

    getTrainOrigin (leg) {
        return this.getIn(['route', leg.id], new List()).first();
    },

    getTrainDestination (leg) {
        return this.getIn(['route', leg.id], new List()).last();
    },

    getTrainOriginStation (leg) {
        const first = this.getTrainOrigin(leg);
        return first && first.station || new Station();
    },

    getTrainDestinationStation (leg) {
        const last = this.getTrainDestination(leg);
        return last && last.station || new Station();
    },

    getLeg (leg) {
        return this.getLegUnfiltered(leg)
            .filter((stop) => stop.station.latitude && stop.station.longitude);
    },

    getLegUnfiltered (leg) {
        if (!leg || !this.route.get(leg.id)) {
            return new List();
        }
        return this.route.get(leg.id)
            .skipUntil((stop) => {
                if (stop.time && leg.origin.first().time) {
                    return stop.time.adjustedTime.isSame(leg.origin.first().time.adjustedTime);
                } else {
                    return stop;
                }
            })
            .skipUntil((stop) => stop.station.nlc === leg.origin.first().station.nlc).reverse()
            .skipUntil((stop) => stop.station.nlc === leg.destination.first().station.nlc).reverse();
    },

    getLegOrigin (leg) {
        const callingPoint = this.getLegUnfiltered(leg).first();
        return callingPoint && callingPoint.station;
    },

    getLegDestination (leg) {
        const callingPoint = this.getLegUnfiltered(leg).last();
        return callingPoint && callingPoint.station;
    },

    getLegStops (leg) {
        return this.getLegUnfiltered(leg).filter((stop) => stop.pattern !== StopPatterns.PASSING);
    },

    getLegStations (leg) {
        return this.getLeg(leg).map((stop) => stop.station);
    },

    getLegStationStops (leg) {
      return this.getLegStops(leg).map((stop) => stop.station);
    }

});

CallingPoints.fromJSON = function (json) {
    json = json || {};

    const callingPoints = _.reduce(json, (acc, leg, id) => {
        acc[id] = resolveAll(_.flatten(leg)).as(StationStop);
        return acc;
    }, {});

    // We need the route part, since response is not
    // record friendly - potentially infinite possible keys
    let result = { route: new Map(callingPoints) };

    return new CallingPoints(result);
};


export default CallingPoints;



// WEBPACK FOOTER //
// ./src/records/CallingPoints.js